import { render } from "./CtaCategorias.vue?vue&type=template&id=ee863640&scoped=true"
import script from "./CtaCategorias.vue?vue&type=script&lang=js"
export * from "./CtaCategorias.vue?vue&type=script&lang=js"

import "./CtaCategorias.vue?vue&type=style&index=0&id=ee863640&scoped=true&lang=scss"

import exportComponent from "C:\\Users\\Public\\frontend\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ee863640"]])

export default __exports__